import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { InfoTooltip } from 'components/InfoTooltip';
import { GeoAutocomplete } from 'components/GeoAutocomplete';
import { useTargetingConfigContext } from './TargetingConfigContext';

export const LocationsConfig = () => {
  const { locations, setLocations } = useTargetingConfigContext();

  return (
    <Stack gap={5} alignItems="flex-start">
      <Box width={{ xs: '100%', sm: '55%' }}>
        <Box display="inline-block" mb={4}>
          <Typography display="inline" fontWeight={700} sx={{ mr: 2 }}>
            Für welche Orte ist die Kampagne relevant?
          </Typography>
          <Box sx={{ display: 'inline-block', transform: 'translateY(-2px)' }}>
            <InfoTooltip
              placement="top"
              text={
                <Stack gap={2}>
                  <Typography variant="body2">
                    Mit Standorten erreichst du Personen, die sich an einem Ort befinden oder sich dort regelmässig
                    aufhalten.
                  </Typography>
                  <Typography variant="body2">
                    Ein Kaufhaus in Bern kann so gezielt Menschen ansprechen, die sich in Bern aufhalten. Ein
                    Onlinehändler kann zum Beispiel Nutzer in unterschiedlichen Kantonen erreichen.
                  </Typography>
                </Stack>
              }
            />
          </Box>
        </Box>
        <GeoAutocomplete label="Orte, PLZ, Kanton, Region" value={locations} onChange={setLocations} />
      </Box>
    </Stack>
  );
};
